import Microfiche from '../Microfiche/Microfiche'
import HiddenButton from '../HiddenButton/HiddenButton'

// Old method
// import Inspector from '../Inspector/Inspector'
// import slugoBiz from '../../slugo-biz.jpg'

const Home = () => {
  const domain = process.env.REACT_APP_DOMAIN

  const handleOverlayClick = () => {
    window.location.href = `${domain}/dashboard/slugo-biz`
  }

  const OverlayContent = () => {
    return (
      <>
        inter-modal freight company located in SoDo
        <br />
        truck pick-up, delivery and rail
        <br />
        he was a...()
        <br />
        Go to: Pike &amp; 10th
        <br />
      </>
    )
  }

  return (
    <>
      {/* <Inspector src={slugoBiz} name="slugo biz" darkHelperOverlay={false} /> */}

      <Microfiche>
        <HiddenButton
          position={{ top: '90px', left: '50px' }}
          onClick={handleOverlayClick}
        />
        <HiddenButton
          position={{ top: '370px', left: '500px' }}
          onClick={handleOverlayClick}
        />
      </Microfiche>
    </>
  )
}

export default Home
